module.exports = __webpack_public_path__ + "media/images/front/noimage-f9babf4cfd635cfcb2165a1153196f44.svg";